import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'walmart-amazon-take',
  template: require('./walmart-amazon-take.component.html'),
  styles: [require('./../blog.component.scss'), require('./walmart-amazon-take.component.scss')]
})
export class WalmartAmazonTakeComponent extends BlogPage {
  title = 'Walmart, Amazon Take Retail Shipping Wars to Sea - Linescape';
  description = 'Retailers are scrambling to claim their share of the global e-commerce market and ocean container shipping is a key piece of the puzzle.';

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/blog/walmart-amazon-take/walmart-amazon-take.component.ts